import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["movedIssues"]

  connect() {
    this.updatePositions();

    this.sortable = Sortable.create(this.movedIssuesTarget, {
      animation: 150,
      handle: '',
      draggable: '.sortable-row',
      onEnd: () => this.updatePositions()
    });
  }

  updatePositions() {
    const issueElements = Array.from(this.movedIssuesTarget.querySelectorAll('div[data-issue-id]'));

    issueElements.forEach((element, index) => {
      const positionInput = element.querySelector(`input[name="survey[issue_orders_attributes][][position]"]`);

      if (positionInput) {
        positionInput.value = index + 1;
      } else {
        const newPositionInput = document.createElement("input");
        newPositionInput.type = "hidden";
        newPositionInput.name = "survey[issue_orders_attributes][][position]";
        newPositionInput.value = index + 1;
        element.appendChild(newPositionInput);
      }
    });
  }

  moveUp(event) {
    const currentElement = event.target.closest('div[data-issue-id]');
    const previousElement = currentElement.previousElementSibling;

    if (previousElement) {
      currentElement.style.transition = "transform 0.2s";
      previousElement.style.transition = "transform 0.2s";

      currentElement.style.transform = "translateY(-100%)";
      previousElement.style.transform = "translateY(100%)";

      setTimeout(() => {
        this.movedIssuesTarget.insertBefore(currentElement, previousElement);
        currentElement.style.transform = "";
        previousElement.style.transform = "";
        this.updatePositions();
      }, 200);
    }
  }

  moveDown(event) {
    const currentElement = event.target.closest('div[data-issue-id]');
    const nextElement = currentElement.nextElementSibling;

    if (nextElement) {
      currentElement.style.transition = "transform 0.2s";
      nextElement.style.transition = "transform 0.2s";

      currentElement.style.transform = "translateY(100%)";
      nextElement.style.transform = "translateY(-100%)";

      setTimeout(() => {
        this.movedIssuesTarget.insertBefore(nextElement, currentElement);
        currentElement.style.transform = "";
        nextElement.style.transform = "";
        this.updatePositions();
      }, 200);
    }
  }
}
